import AppLogo from "../../components/AppLogo";
import LoginForm from "../../components/forms/login";

export default function LoginPage() {
  return (
    <main className="flex items-center justify-center md:h-screen">
      <div className="relative mx-auto flex w-full max-w-[400px] flex-col space-y-2.5 p-4 md:-mt-32">
        <div className="flex h-16 w-full items-end rounded-lg bg-[var(--color-action-primary)] p-3 md:h-24">
          <div className="text-white">
            <AppLogo />
          </div>
        </div>
        <LoginForm />
      </div>
    </main>
  )
}
